import crypto from 'crypto';

export default function decrypt(encryptedText, account_type){
  
  const key = (account_type === "Business" ? process.env.REACT_APP_KEY_CORPORATE : process.env.REACT_APP_KEY_CONSUMER) || '4579263ED2364304A5B626F744C08374';
  
  var decipher = crypto.createDecipheriv('aes-256-ecb', key.toString('binary'), '');
  decipher.setAutoPadding(false);
  var dec = decipher.update(encryptedText,'hex','utf8');
  dec += decipher.final('utf8');
  return dec;
}